import '../styles/Prev.css';
import '../styles/Grille.css';
import '../styles/Rules.css';

import { useTranslation } from 'react-i18next';

function Rules() {
    const { t } = useTranslation();
	return (
        <div className='rules'>
            <h2>{t('rules.title')}</h2>
            <p>{t('rules.description')}</p>
            <div className="grille-rules">
                <div className="grille-row">
                    <div className='grille-cell green'>{t('rules.correct')}</div>
                    <div className='grille-cell red'>{t('rules.incorrect')}</div>
                    <div className='grille-cell orange'>{t('rules.partial')}</div>
                    <div className='grille-cell red before'>{t('rules.before')}<img src='/images/assets/arrow_down.png' alt='arrow_down' /></div>
                    <div className='grille-cell red after'>{t('rules.after')}<img src='/images/assets/arrow_up.png' alt='arrow_up' /></div>
                </div>
            </div>
        </div>
	)
}

export default Rules
